import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import postsFeedInit from './redux/postsFeedInit';

export const getPostsFeedWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  initActionsCreator: postsFeedInit,
});
